import { RE } from "country-flag-icons/react/3x2";
import { TIMEOUT } from "dns";

const enJSON = {
    LOGO: {
      VERSION: '1.0',
      VERSION_DESC: 'First Version',
      SYSTEM_NAME: 'Citas Tránsito Chihuahua'
    },
    MY_ACCOUNT: {
      HEADING: "My account",
      SUBHEADING: "General information and account settings",
      USER_DETAILS: "User details",
      USER_DETAILS_DESCRIPTION: "Manage user information",
      BTN_CHANGE_PASSWORD: "Change password",
      BTN_EDIT: "Edit",
      ACCOUNT_EDIT: "Edit profile",
      ACCOUNT_EDIT_DESCRIPTION: "Form to edit profile",
      PROFILE_INFO_UPDATED: "Profile information has been updated",
      PROFILE_INFO_UPDATED_WITH_ERROR: "The profile information has been updated, but, an error occurred when displaying the updated data.",
      CHANGE_PASSWORD_HEADING: "Change password",
      CHANGE_PASSWORD_SUBHEADING: "Form to change password",
    },
    LOGIN: {
      HEADING: "Login",
      SUBHEADING: "Fill in the fields below to log in.",
      REGISTER: "Sign up",
      DONT_YOU_HAVE_AN_ACCOUNT: "Don't have an account?",
      LOST_PASSWORD: "Forgot your password?"
    },
    REGISTER: {
      HEADING: "Register account",
      SUBHEADING: "Complete the fields below to create a new account.",
      BACK_TO: "Back to",
      USER_REGISTERED: "The user has registered"
    },
    LANGUAGE_SWITCHER: {
      HEADING: "language",
      SUBHEADING: "Change language"
    },
    RECOVER_PASSWORD: {
      HEADING: "Password recovery",
      SUBHEADING: "Enter your email address to reset your password",
      BACK_TO_LOGIN: "Do you want to log in again?",
      INSTRUCTIONS: "Instructions for recovering your password have been sent to your email address.",
      CHECK_MAIL: "Check your email to recover your password",
      TO_LOGIN: "Go to login"
    },
    ROLES: {
      HEADING: "Roles",
      SUBHEADING: "Administration of roles and permissions",
      CREATE: "Create role",
      CREATE_DESC: "Fill in the form to create a role",
      EDIT: "Edit role",
      EDIT_DESC: "Complete the form to edit the role",
      SHOW: "Role details",
      SHOW_DESC: "Complete information of the selected role",
      DELETE: "Delete role",
      DELETE_CONFIRM_MESSAGE: "Do you really want to delete the selected role?",
      DELETED: "The selected role has been deleted",
      SEARCH: "Search by name or description",
      PERMISSIONS: "Permissions",
      SAVED: "The role has been saved.",
      EDITED: "The role has been edited."
    },
    USERS: {
      HEADING: "Users",
      SUBHEADING: "User administration",
      CREATE: "Create user",
      CREATE_DESC: "Fill in the form to create a user",
      EDIT: "Edit user",
      EDIT_DESC: "Fill in the form to edit a user",
      SHOW: "User details",
      SHOW_DESC: "Full information of the selected user",
      DELETE: "Delete user",
      DELETE_CONFIRM_MESSAGE: "Do you really want to delete the selected user?",
      DELETED: "The selected user has been deleted",
      SEARCH: "Search by user name or e-mail",
      ACTIVE: {
        0: 'Disabled',
        1: 'Enabled'
      }
    },
    RESET_PASSWORD: {
      HEADING: "Reset password",
      SUBHEADING: "Fill in the fields to reset your password",
      INSTRUCTIONS: "You can now log in with your new password",
      SUCCESS: "The password has been reset",
      TO_LOGIN: "Go to login"
    },
    EMAIL_VERIFICATION: {
      HEADING: "Mail verification",
      SUBHEADING: "It is necessary to verify your e-mail address to use the system. \A verification email was sent when you registered. If you did not receive it, you can request another one by clicking the following button.",
      BUTTON: "Request a verification email",
      SUCCESS: "Verification mail has been sent to the registered address."
    },
    VERIFY_EMAIL: {
      HEADING: "Mail verification",
      SUBHEADING: "The e-mail address must be verified in order to use the system.",
      VERIFYING: "Verifying e-mail",
      VERIFIED: "Your email has been successfully verified, you will be redirected to the home page.",
      VERIFIED_ERROR: "There was an error verifying your email address, you can request a new verification email address by clicking on the following button",
      VERIFY: "Verify e-mail",
      BUTTON: "Go to request a verification email"
    },
    THEME_SETTINGS: {
      CHOOSE_LAYOUT: "Select distribution",
      CHOOSE_THEME: "Select theme",
      ADMIN_PANEL_LAYOUT: "Administrator panel layout",
      ADMIN_PANEL_LAYOUT_DESCRIPTION: "Change the arrangement of the information",
      ADMIN_PANEL_THEME: "Administrator panel theme",
      ADMIN_PANEL_THEME_DESCRIPTION: "Change colors",
      THEMES: {
        PURE_LIGHT_THEME: "Pure Light",
        GRAY_GOOSE_THEME: "Gray Goose",
        PURPLE_FLOW_THEME: "Purple Flow"
      },
      LAYOUTS: {
        EXTENDED_SIDEBAR: "Extended Sidebar",
        ACCENT_HEADER: "Accent Header",
        ACCENT_SIDEBAR: "Accent Sidebar",
        BOXED_SIDEBAR: "Boxed Sidebar",
        COLLAPSED_SIDEBAR: "Collapsed Sidebar",
        BOTTOM_NAVIGATION: "Bottom Navigation",
        TOP_NAVIGATION: "Top Navigation"
      },
    },
    FIELDS: {
      USERNAME: "User",
      EMAIL: "E-mail address",
      NAME: "Name",
      LASTNAME: "Last name",
      CURRENT_PASSWORD: "Current password",
      PASSWORD: "Password",
      PASSWORD_CONFIRMATION: "Password confirmation",
      REMEMBER: "Remember",
      DESCRIPTION: "Description",
      ID: "Id",
      CREATED_AT: "Created",
      UPDATED_AT: "Updated",
      ROLE: "Role",
      ROLE_ID: "Role",
      ACTIVE: "Status",
      EMAIL_VERIFIED_AT: 'Verified',
      MUNICIPALITY: 'Municipality',
      QUOTES: "Appointments",
      WEEKS: "Repeats?",
      OPENING_TIME: "Opening time",
      CLOSING_TIME: "Closing time",
      MODULE: 'Module',
      LICENCE_TYPE: 'License type',
      FORMALITY: 'Formality',
      ALL: "All",
      ALL_POSSIBLE_TIMES: "All possible times",
      AND: " and ",
      DATE_AVAILABILITY_DETAILS: "Appointment availability",
      AVAILABLE_DAYS: "Appointment availability",
      LAST_NAME: "Last Name",
      SECOND_LAST_NAME: "Second Last Name",
      CURP: "CURP",
      ADDRESS: "Address",
      RFC: "RFC",
      SEX: "Sex",
      BIRTHDATE: "Date of birth",
      MARITAL_STATUS: "Marital status",
      NATIONALITY_ID: "Nationality",
      NATIONALITY: "Nationality",
      PHONE: "Phone",
      OCCUPATION: "Occupation",
      EMERGENCY_CONTACT: "Emergency contact",
      MINOR_TUTOR: "Guardian",
      CITIZEN_FOREIGNS: "Foreigners",
      FOLIO_ID: 'Folio',
      DATE: 'Date',
      TIME: 'Time',
      ASSISTANCE: 'Attendance',
      APPOINTMENT_TYPE: 'Estado',
      DAY: "Day",
      ALL_EXCEPT_FIRST_TIME: "All except first time",
      USER: 'User',
      TABLE: 'Modified table',
      INI_DATE: 'Start date',
      FIN_DATE: 'Final date',
      AFTER: 'Saved',
      BEFORE: 'Before saving',
      DATE_AVAILABILITY_DETAILS_EXCEPTION: 'Exceptions in appointment availability',
      WEEKS_ON_REPIT: 'Semanas que se repite',
      SCHEDULE: 'Schedule:',
      NO_FILTER: 'No filter',
    },
    VALIDATION: {
      REQUIRED: "The field is required.",
      EMAIL: "The e-mail address must be valid.",
      MIN_ONE: "It is necessary to select at least 1.",
      MAX_OPENING_TIME: "The opening time must be less than the closing time.",
      MIN_CLOSING_TIME: "Closing time must be longer than the opening time."
    },
    GENERAL: {
      CANCEL: "Cancel",
      LOGOUT: "Logout",
      CLOSE: "Close",
      NO_RESULTS: "No results found",
      SEARCH: "Search",
      ACTIONS: "Actions",
      GO_TO_HOMEPAGE: "Back to home",
      BULK_ACTIONS: "Massive actions",
      BULK_DELETE: "Delete selected",
      SELECT_BETWEEN_VIEWS: "Select the layout to display the list between a table and cards.",
      RESET: 'Reset form',
      ENABLE: "Enabled",
      DISABLED: "Disabled"
    },
    STATUS: {
      404: {
        MESSAGE: "Page not found"
      },
      403: {
        MESSAGE: "No permissions to perform this action"
      },
      401: {
        MESSAGE: "Not logged in or session has expired"
      }
    },
    SETTINGS: {
      HEADING: 'Settings',
      SUBHEADING: 'System configuration',
      CREATE: "Create user",
      CREATE_DESC: "Fill in the form to create a user",
      EDIT: "Edit user",
      EDIT_DESC: "Complete the form to edit the user",
      SHOW: "User details",
      SHOW_DESC: "Full information of the selected user",
      DELETE: "Delete user",
      DELETE_CONFIRM_MESSAGE: "Do you really want to delete the selected user?",
      DELETED: "The selected user has been deleted",
      SEARCH: "Search by user name or e-mail",
      SYSTEM_ADDRESSES_UPLOAD: 'Excel zip codes',
      SYSTEM_ADDRESSES_UPLOAD_DESC: 'It is necessary to import the zip code file, you can find it in the following link: ',
      ADDRESSES: 'Zip codes',
      SYSTEM_ADDRESSES_SUBMIT: 'Save file'
    },
  
    "LICENCE-TYPES": {
      HEADING: 'License types',
      SUBHEADING: 'Different types of licenses',
      CREATE: "Create license type",
      CREATE_DESC: "Fill in the form",
      EDIT: "Edit license type",
      EDIT_DESC: "Fill in the form to edit",
      SHOW: "Details",
      SHOW_DESC: "Full information",
      DELETE: "Delete",
      DELETE_CONFIRM_MESSAGE: "Do you really want to delete the item?",
      DELETED: "The selected item has been deleted",
      SEARCH: "Search"
    },
    MODULES: {
      HEADING: 'Modules',
      SUBHEADING: 'Module configuration',
      CREATE: "Create module",
      CREATE_DESC: "Fill in the form",
      EDIT: "Edit module",
      EDIT_DESC: "Fill in the form to edit",
      SHOW: "Details",
      SHOW_DESC: "Full information",
      DELETE: "Delete",
      DELETE_CONFIRM_MESSAGE: "Do you really want to delete the item?",
      DELETED: "The selected item has been deleted",
      SEARCH: "Search"
    },
    FORMALITIES: {
      HEADING: 'Formalities',
      SUBHEADING: 'List of formalities',
      CREATE: "Create formality",
      CREATE_DESC: "Fill in the form",
      EDIT: "Edit formality",
      EDIT_DESC: "Fill in the form to edit",
      SHOW: "Details",
      SHOW_DESC: "Complete information",
      DELETE: "Delete",
      DELETE_CONFIRM_MESSAGE: "Do you really want to delete the item?",
      DELETED: "The selected item has been deleted",
      SEARCH: "Search"
    },
    IDENTIFICATIONS: {
      HEADING: 'Identifications',
      SUBHEADING: 'Identifications list',
      CREATE: "Create citizen identification",
      CREATE_DESC: "Fill in the form",
      EDIT: "Edit citizen identification",
      EDIT_DESC: "Fill in the form to edit",
      SHOW: "Details",
      SHOW_DESC: "Complete information",
      DELETE: "Delete",
      DELETE_CONFIRM_MESSAGE: "Do you really want to delete the item?",
      DELETED: "The selected item has been deleted",
      SEARCH: "Search"
    },
    "ADDRESS-VERIFICATION-DOCUMENTS": {
      HEADING: 'Verification documents',
      SUBHEADING: 'Verification documents list',
      CREATE: "Creat verification document",
      CREATE_DESC: "Fill in the form",
      EDIT: "Edit verification document",
      EDIT_DESC: "Fill in the form to edit",
      SHOW: "Details",
      SHOW_DESC: "Complete information",
      DELETE: "Delete",
      DELETE_CONFIRM_MESSAGE: "Do you really want to delete the item?",
      DELETED: "The selected item has been deleted",
      SEARCH: "Search"
    },
    NATIONALITIES: {
      HEADING: 'Nationalities',
      SUBHEADING: 'Nationalities list',
      CREATE: "Create Nationality",
      CREATE_DESC: "Fill in the form",
      EDIT: "Edit nationality",
      EDIT_DESC: "Fill in the form to edit",
      SHOW: "Details",
      SHOW_DESC: "Complete information",
      DELETE: "Delete",
      DELETE_CONFIRM_MESSAGE: "Do you really want to delete the item?",
      DELETED: "The selected item has been deleted",
      SEARCH: "Search"
    },
    "DATES-AVAILABILITY": {
      HEADING: "Appointment availability",
      SUBHEADING: 'Availability of appointments in the modules',
      CREATE: "Add appointment availability",
      CREATE_DESC: "Fill in the form",
      EDIT: "Edit appointment availability",
      EDIT_DESC: "Fill in the form to edit",
      SHOW: "Details",
      SHOW_DESC: "Complete information",
      DELETE: "Delete",
      DELETE_CONFIRM_MESSAGE: "Do you really want to delete the item?",
      DELETED: "The selected item has been deleted",
      ERROR:"There was an error in obtaining the necessary data to create an appointment availability.",
      ERROR_AVAILABILITY:"There was an error in obtaining the necessary data for the filters.",
      SEARCH: "Search",
      'WEEKS-TEXT': {
        1: "First week",
        2: "Second week",
        3: "Third week",
        4: "Fourth week",
      },
      'DAY-TEXT': {
        Mon: 'Monday',
        Tue: 'Tuesday',
        Wed: 'Wednesday',
        Thu: 'Thursday',
        Fri: 'Friday',
        Sat: 'Saturday',
        Sun: 'Sunday'
      },
      ADD_AVAILABILITY: "Add availability",
      CLEAR_FILTERS: "Clean filters"
    },
    CITIZENS: {
      HEADING: 'Citizens',
      SUBHEADING: 'Citizens list',
      CREATE: "Create citizen",
      CREATE_DESC: "Fill in the form",
      EDIT: "Edit citizen",
      EDIT_DESC: "Fill in the form to edit",
      SHOW: "Details",
      SHOW_DESC: "Complete information",
      DELETE: "Delete",
      DELETE_CONFIRM_MESSAGE: "Do you really want to delete the item?",
      DELETED: "The selected item has been deleted",
      SEARCH: "Search"
    },
    APPOINTMENTS: {
      HEADING: 'Appointments list',
      SUBHEADING: 'List of registered appointments',
      SEARCH: 'Search by folio, curp or name',
      EXPORT: 'Export to excel'
    },
    DASHBOARD: {
      HEADING: 'List of appointments'
    },
    "NONWORKING-DAYS": {
      HEADING: 'Non-working days',
      SUBHEADING: 'List of non-working days',
      CREATE: "Register non-working day",
      CREATE_DESC: "Fill in the form",
      EDIT: "Edit non-working day",
      EDIT_DESC: "Fill in the form to edit",
      SHOW: "Details",
      SHOW_DESC: "Complete information",
      DELETE: "Delete",
      DELETE_CONFIRM_MESSAGE: "Do you really want to delete the item?",
      DELETED: "The selected item has been deleted",
      SEARCH: "Search"
    },
    "CHANGE-LOG": {
      HEADING: 'Change-log history',
      SUBHEADING: 'History of recorded changes ',
      SHOW: "Details",
      SHOW_DESC: "Complete information",
    },
  
    "DATES-AVAILABILITY-EXCEPTION": {
      HEADING: "Exception in appointment availability",
      SUBHEADING: 'Exceptions in the availability of appointments in the modules',
      CREATE: "Add exception in appointment availability",
      CREATE_DESC: "Fill in the form",
      EDIT: "Edit exception in appointment availability",
      EDIT_DESC: "Fill in the form to edit",
      SHOW: "Detalls",
      SHOW_DESC: "Complete information",
      DELETE: "Delete",
      DELETE_CONFIRM_MESSAGE: "Do you really want to delete the item?",
      DELETED: "The selected item has been deleted",
      SEARCH: "Search",
    },
  
    "DUPLICATED-APPOINTMENT":{
      TITLE: "Appointment already scheduled for this type of license",
      INFO:"You already have a scheduled appointment for this type of driver's license, you can cancel your appointment in the home page by selecting “CANCEL APPOINTMENT”, entering your appointment folio that is on your confirmation sheet that was sent to you by mail, and then you can schedule a new appointment, or if you require more information you can call us by phone:",
      CONTACT_DATA_RENOVATION:"Renewal:",
      CONTACT_DATA_RENOVATION_CH:"Cd. Chihuahua: 614 429 3300 Ext. 20511",
      CONTACT_DATA_RENOVATION_JU:"Cd. Juárez: 656 629 3300 Ext. 55254",
      CONTACT_DATA_FIRSTIME: "First time license:",
      CONTACT_DATA_FIRSTIME_CH: "Cd. Chihuahua: 614 429 3300 Ext. 20963 y 20964",
      CONTACT_DATA_FIRSTIME_JU: "Cd. Juárez: 656 629 3300 Ext. 55254",
      BUTTON: "Accept"
    },

    "DAYS":{
      MONDAY: "Monday",
      TUESDAY: "Tuesday",
      WEDNESDAY: "Wednesday",
      THURSDAY: "Thursday",
      FRIDAY: "Friday",
      SATURDAY: "Saturday",
      SUNDAY: "Sunday"
    },

    "HOME":{
      WELCOME: "Welcome!",
      SUBHEADING: "This is a driver license procedure:",
      START: "Start",
      TIMEOUT: "Time out!",
      TIMEOUT_MESSAGE: "We ran out of time to schedule your appointment. Please try again.",
      BACK_HOME: "Back to home",
      ERROR_FORM: "There was an error in obtaining the necessary data for the form.",
      PROCESS: "Process",
      TIME_REMAINING: "Remaining time to schedule an appointment:",
      SELECT_PROCEDURE: "Select the procedure you need to do.",
      FIRST_TIME: "First time license",
      RENEWAL: "Renewal",
      EXCHANGE: "Exchanges",
      LOST:"Lost",
      STOLEN: "Stolen",
      FOREIGNERS: "Foreigners",
      NON_LOCALS: "From another state",
      TRANSPORT:"Public transport and freight transport",
      CANCEL_APPOINTMENT: "Cancel an appointment",
      DRAG_FILE: "Drag the files to load them",
      DONT_ALLOWED_FILES: "You cannot upload this type of file",
      DRAG_DROP_FILE: "Drag and drop the file here",
      FIRST_TIME_DESCRIPTION: "First time driver's license application.",
      RENEWAL_DESCRIPTION: "Driver's license renewal process.",
      EXCHANGE_DESCRIPTION: "Procedure for the exchange of current license.",
      LOST_DESCRIPTION: "Procedure for the exchange of a lost license.",
      STOLEN_DESCRIPTION: "Procedure for the exchange of a license that has been stolen.",
      FIRST_TIME_DESCRIPTION2: "First time driver's license application in the state of Chihuahua.",
      TRANSPORT_DESCRIPTION: "Processing of license for public transport.",
      SERVICE_PHONE: "Please contact the State Transportation Department at 429.33.00 ext. 24909 and 24913 for more information.",
      SELECT_LICENSE_TYPE: "Select license type",
      SELECT_MODULE: "Select the module of your city",
      SELECT_DATE: "Select an available date",
      SELECTED: "Selected",
      AVAILABLE: "Available",
      UNAVAILABLE: "Full",
      NO_WORKING_DAY: "Non-service day",
      SELECT_HOUR: "Select appointment time",
    },
    
    "ERRORS": {
      NOT_VALID_CURP: "The CURP is not valid",
      NOT_VALID_NAME: "The name is not valid, do not enter symbols or spaces at the end of the name",
      NOT_VALID_LASTNAME: "The last name is not valid, do not enter symbols or spaces at the end of the name",
      ONLY_ONE_LASTNAME: "If you have only one last name, enter it in the First Last Name field.",
      RFC_NOT_VALID: "The RFC is not valid",
      NOT_VALID_DATE: "The date is not valid",
      DATE_CURP_NOT_MATCHING: "The date does not match the CURP",
      NOT_VALID_PHONE: "The phone number is not valid",
      ZIP_CODE_NOT_VALID: "The zip code is not valid",
      RFC_NOT_MATCHES_CURP: "RFC does not match CURP",
      PASSWORD_CHANGED: "Your password has changed.",
      MAKE_APPOINTMENT: "There was an error in setting aside the appointment.",
      MINOR_ERROR: "Please select the correct license, minor was selected.",
      ADULT_ERROR: "Please select the correct license, you are of legal age.",
      MINOR_DONT_ALLOWED: "Minors under 16 years of age are not allowed to apply for licenses.",
      MINOR_TUTOR_DONT_ALLOWED: "Minors under 18 years of age cannot be guardians",
      ERROR_GENERATING: "There was an error generating the appointment.",
      MAX_LENGTH_EXCEEDED: "The maximum length of the field has been exceeded.",

    },

    "BLOCK_1": {
    REQUIREMENTS_DESCRIPTION:"The applicant must submit the following requirements in original:",
    BIRTH_CERTIFICATE: "Birth Certificate (Original)",
    PAYMENT_RECEPT:"Receipt of payment for validation of theoretical and practical driving skills for vehicles",
    MOTORCYCLE_REQUIREMENTS:"In case of motorcycle license, present (motorcycle and helmet) only in Chihuahua City.",
    TUTOR:"Parent or legal guardian must bring official identification and a copy of the same.",
    IMPORTANT_MESSAGES: "IMPORTANT MESSAGES",
    ON_TIME:"Arrive 30 minutes before your appointment, as it will expire at the scheduled time.",
    PRINT_APPOINTMENT: "To receive service, it is essential to present your printed and/or digital appointment (this document) and carry a valid official ID with photo and signature.",
    REQUIREMENTS_CHECK: "It is important to meet all the requirements as outlined in your appointment details",
    PAYMENT_INFO: "You must pay for the course to validate your theoretical and practical driving skills",
    WHERE_PAY:"The course payment can be made on the same day of your appointment at the Revenue Collection counters within the same facility.",
    ID:"Official identification (INE, Mexican passport, military ID, professional ID, in the case of minors: valid school ID, valid Mexican passport), must be presented with father, mother or legal guardian.",
    ON_TIME_SHORT_DESCRIPTION: "Please, arrive 30 minutes before your appointment.",
    MANDATORY_TEST: "The applicant must attend the driving course and pass the theorical/practical tests at the traffic education department. ",
    BLOOD_TYPE: "It is important to KNOW your blood type.",
  },

    "BLOCK_6": {
      HEADING: "Foreign driver's license",
      SUBHEADING: "Processing of driver's license for foreigners.",
      BLOOD_TYPE: "To carry out any procedure, you must KNOW your CURP and your blood type.",
      REQUIREMENTS: "The foreign applicant must bring the following requirements in original:",
      PASSPORT: "Passport from country of origin",
      TEMPORARY_RESIDENCE: "Temporary residence",
      TEMPORARY_LICENSE: "Temporary permit: Present passport from your country, prove domicile and your license is authorized only for 1 or 3 years.",
      PERMANENT_LICENSE: "Permanent permit: Previous license, permanent permit, prove domicile and your license is authorized for up to 6 years.",
      THEORETICAL_TEST: "You must take a theoretical and practical exam, in case of first time, you must do your procedure in the “First Time” option.",
      ADDRESS_PROOF: "Proof of address",
      ADDRESS_PROOF_DESCRIPTION: "Proof of official address in the name of the interested party, recent date (water, electricity, natural gas, property tax or active telephone number). In case is not in your name, it must be accompanied by a bank or department store statement with the same address as the official receipt and/or letter of resolution from Immigration. In case of minors, present proof of address in the name of the legal guardian.",
      PARTICULAR_DRIVER: "Particular standar driver",
      PARTICULAR_DRIVER_DESCRIPTION: "Authorizes the interested party to drive private vehicles with up to twelve seats, or private cargo vehicles whose maximum authorized weight does not exceed 3.5 Tons.",
      PARTICULAR_COMMERCIAL_DRIVER: "Particular non-commercial or commercial driver",
      PARTICULAR_COMMERCIAL_DRIVER_DESCRIPTION: "Authorizes the interested party to drive private vehicles with up to twelve seats, or private cargo vehicles whose maximum authorized weight does not exceed 3.5 Tons.",
      MOTORCYCLE: "Motorcycle",
      MOTORCYCLE_DESCRIPTION: "Authorizes the interested party to drive any type of motorcycles.",
      ARTICLE_LAW:"In accordance with article 54 of the Traffic Law for the State of Chihuahua in force.",

    },

    "PREFIXES":{
      STREET:"St.",
      AVENUE:"Ave.",
      BOULEVARD:"Blvd.",
      ALLEY:"Alley",
      ROAD:"Rd.",
      HIGHWAY_KM:"KM-Highway",
      PRIVATE_STREET:"Private St.",
      CONOCIDO:"Conocido",
      INDUSTRIAL_PARK:"Par-Ind",
      BELTWAY:"Beltway.",
      CUL_DE_SAC: "Cul-de-sac",
    },

    "FINAL":{
      WARNING: "Warning!",
      COMPLETE_FORM: "Fill the form",
      ADDRESS_DATA: "Address data",
      PREFIX: "Prefix",
      STREET: "Street",
      EXTERNAL_NUMBER: "External number",
      INTERNAL_NUMBER: "Internal number",
      ZIP_CODE: "Zip code",
      STATE: "State",
      MUNICIPALITY: "Municipality",
      NEIGHBORHOOD: "Neighborhood",
      NAME: "Name(s)",
      FIRST_LASTNAME: "First last name",
      SECOND_LASTNAME: "Second last name",
      PHONE: "Phone",
      EMAIL: "E-mail",
      SEX: "Sex",
      BIRTHDATE: "Date of birth",
      CIVIL_STATUS: "Civil status",
      OCUPATION:"Occupation",
      NATIONALITY: "Nationality",
    },

    OCCUPATIONS:{
      STUDENT: "Student",
      EMPLOYEE: "Employee",
      UNEMPLOYED: "Unemployed",
      HOUSEWIFE: "Housewife",
      RETIRED: "Retired",
      SELF_EMPLOYED: "Self-employed",
    },
  };

export default enJSON;
